export default __webpack_public_path__ + "static/media/flower-4.fbb7e891.svg";